export const mockLaborCostCalc = [
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 1,
        no: "품-1",
        name: "고압케이블 포설",
        type: "240㎟, 1C",
        occupation: "고압 케이블전공",
        manPerDay: 0.136,
        surchargeRatio: 1.15,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 2,
        no: "품-2",
        name: "저압케이블 포설",
        type: "6㎟, 2C",
        occupation: "저압 케이블전공",
        manPerDay: 0.018,
        surchargeRatio: 1.2,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 3,
        no: "품-2",
        name: "저압케이블 포설",
        type: "2.5㎟, 6C",
        occupation: "저압 케이블전공",
        manPerDay: 0.035,
        surchargeRatio: 1.2,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 4,
        no: "품-3",
        name: "전력케이블 단말처리",
        type: "240㎟, 1C",
        occupation: "ALL",
        manPerDay: 1.17,
        surchargeRatio: 1.2,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 5,
        no: "품-4",
        name: "Cubicle 설치",
        type: "6㎾, 1.5 Ton이하",
        occupation: "비계공",
        manPerDay: 2.0,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 6,
        no: "품-4",
        name: "Cubicle 설치",
        type: "6㎾, 1.5 Ton이하",
        occupation: "변전전공",
        manPerDay: 4.05,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 7,
        no: "품-4",
        name: "Cubicle 설치",
        type: "6㎾, 1.5 Ton이하",
        occupation: "보통인부",
        manPerDay: 3.3,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 8,
        no: "품-4",
        name: "Cubicle 설치",
        type: "10㎾, 3 Ton 이하",
        occupation: "비계공",
        manPerDay: 4.0,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 9,
        no: "품-4",
        name: "Cubicle 설치",
        type: "10㎾, 3 Ton 이하",
        occupation: "변전전공",
        manPerDay: 7.05,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 10,
        no: "품-4",
        name: "Cubicle 설치",
        type: "10㎾, 3 Ton 이하",
        occupation: "보통인부",
        manPerDay: 5.6,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 11,
        no: "품-5",
        name: "전기실 전원 케이블 포설",
        type: "50sq, 3C",
        occupation: "저압 케이블전공",
        manPerDay: 0.043,
        surchargeRatio: 2.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 12,
        no: "품-6",
        name: "케이블 트레이",
        type: "단면적 50,000㎟ 이하",
        occupation: "내선전공",
        manPerDay: 0.2,
        surchargeRatio: 1.44,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 13,
        no: "품-6",
        name: "케이블 트레이",
        type: "단면적 30,000㎟ 이하",
        occupation: "내선전공",
        manPerDay: 0.16,
        surchargeRatio: 1.44,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 14,
        no: "품-7",
        name: "통신케이블 포설",
        type: "지중 인력관인 포설",
        occupation: "보통인부",
        manPerDay: 1.41,
        surchargeRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 15,
        no: "테스트",
        name: "테스트",
        type: "테스트",
        occupation: "저압 케이블전공",
        manPerDay: 1.0,
        surchargeRatio: 0.01,
    },
];
export const mockOutputRatio = [
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 1,
        type: "간접 노무비",
        formula: "직접노무비X12.2%",
        ratio: 0.122,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 2,
        type: "고용보험료",
        formula: "노무비X1.01%",
        ratio: 0.0101,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 3,
        type: "공제수료",
        formula: "직접노무비X3%",
        ratio: 0.03,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 4,
        type: "여비교통 통신비",
        formula: "노무비X0.418%",
        ratio: 0.00418,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 5,
        type: "산재보험료",
        formula: "노무비X3.7%",
        ratio: 0.037,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 6,
        type: "세금과공과",
        formula: "노무비X0.13%",
        ratio: 0.0013,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 7,
        type: "복리후생비",
        formula: "노무비X2.397%",
        ratio: 0.02397,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 8,
        type: "퇴직공제 부금비",
        formula: "직접노무비X2.3%",
        ratio: 0.023,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 9,
        type: "소모품비",
        formula: "노무비X1.479%",
        ratio: 0.01479,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 10,
        type: "산업안전보건관리비",
        formula: "직접노무비X1.85%X1.2",
        ratio: 0.0222,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 11,
        type: "일반관리비",
        formula: "(재료비+노무비+경비)X6%",
        ratio: 0.06,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 12,
        type: "이윤",
        formula: "(노무비+경비+일반관리비)X15%",
        ratio: 0.15,
    },
];
export const mockMarketWageUnitPrice = [
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 1,
        occupation: "저압 케이블전공",
        unitPrice: 290333.0,
        adjustmentRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 2,
        occupation: "고압 케이블전공",
        unitPrice: 353395.0,
        adjustmentRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 3,
        occupation: "비계공",
        unitPrice: 281721.0,
        adjustmentRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 4,
        occupation: "변전전공",
        unitPrice: 451145.0,
        adjustmentRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 5,
        occupation: "보통인부",
        unitPrice: 161858.0,
        adjustmentRatio: 1.0,
    },
    {
        creater: 1,
        modifier: 1,
        createdTime: "2024-01-01T00:00:00.000Z",
        modifiedTime: "2024-01-01T00:00:00.000Z",
        deletedYn: 0,
        id: 6,
        occupation: "내선전공",
        unitPrice: 269968.0,
        adjustmentRatio: 1.0,
    },
];
